import styled from '../../../styles/styledComponents/themeComponents';

export const SelectListStyle = styled.div`
  tr.invalid {
    background: #f76707;
  }
`;
